module.exports = __webpack_public_path__ + "img/pendencies_icon_grey.84b2784f.svg";